import { MouseEvent } from 'react';

import { Box } from 'components/Box';
import { AnchorButton } from 'components/Button/AnchorButton';
import { SaveButton } from 'components/SaveButton';
import { ShareListingButton } from 'components/ShareListingButton';
import { NoAmp } from 'containers/NoAmp';
import { ApiOrg } from 'modules/listing/api/org/types/ApiOrg';
import { ListingActionsDropdown } from 'modules/listing/components/ListingActionsDropdown';

import { orgHasListings } from './orgHasListings';

type Props = {
  org: ApiOrg;
  isPreview: boolean;
  onClickOpportunities: (
    e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
    analyticsProperties?: Record<string, unknown>,
  ) => void;
  mobile: boolean;
};

export function ViewOrgPageActionButtons({
  org,
  isPreview,
  onClickOpportunities,
  mobile,
}: Props) {
  return (
    <Box display="flex" flexWrap="wrap">
      {orgHasListings(org) && (
        <Box m="4px">
          <AnchorButton
            href="#opportunities"
            variant="primary"
            onClick={(e) =>
              onClickOpportunities(e, {
                type: 'Button Top',
              })
            }
          >
            {getText('See opportunities')}
          </AnchorButton>
        </Box>
      )}
      <NoAmp>
        <>
          <Box m={1}>
            <SaveButton
              disabled={isPreview}
              listingId={org.id}
              listingType={org.type}
              listingName={org.name}
            />
          </Box>
          {!mobile && (
            <Box m={1}>
              <ShareListingButton
                listingId={org.id}
                listingType="ORG"
                listingUrl={org.url}
                disabled={isPreview}
              />
            </Box>
          )}
          <Box m={1}>
            <ListingActionsDropdown
              mobilePlacement="up"
              listingId={org.id}
              listingType="ORG"
              listingUrl={org.url}
            />
          </Box>
        </>
      </NoAmp>
    </Box>
  );
}
